// extracted by mini-css-extract-plugin
export default {"version":"AboutPane_version__iVJbU","wrapper":"AboutPane_wrapper__hz09F"};